






























































































































  import { Component, Prop, Vue } from 'nuxt-property-decorator'
  import { converters } from '@one/core'
  import { namespace } from 'vuex-class'
  import { BindingHelpers } from 'vuex-class/lib/bindings'
  import isUndefined from 'lodash/isUndefined'
  import { WishlistProduct, WishlistProductPricesDto } from '@one/types'
  import { CartProductPrice } from '~/store/cart/getters'
  import { MappedWishlist } from '~/store/wishlist/types'
  import OneProductStocksLabel from '~/components/organisms/product/OneProductStocksLabel.vue'
  import { StockVisibilityMode } from '@one/types/dist/orderpath/app/shared'

  const stocks: BindingHelpers = namespace('stocks')
  const layout: BindingHelpers = namespace('layout')
  const categories: BindingHelpers = namespace('categories')
  const wishlist: BindingHelpers = namespace('wishlist')

  export interface CustomProductShipment {
    id: string
    productAvailability: Array<any>
    numberOfProducts: number
    contextWarehouseType: string
  }
  @Component({
    components: {
      OneProductStocksLabel,
      OnePromotionInfo: () => import('~/components/organisms/cart/OnePromotionInfo.vue'),
      OneCartProductRowLineActions: () =>
        import('~/components/molecules/dropdowns/OneCartProductRowLineActions.vue'),
      OneProductTitleLabels: () =>
        import('~/components/molecules/images/OneProductTitleLabels.vue'),
    },
  })
  export default class OneWishlistProductRowLine extends Vue {
    quantityInOrderUnit: number = 1
    qtyError: boolean = false
    debounceValue = 250
    currentValue: number = 0
    buttonLoading: boolean = false
    @categories.Getter getCategory: any
    @stocks.Getter getWarehouse: any
    @layout.Getter getCurrency: any
    @layout.Getter isGrossSelected: any
    @wishlist.Getter getCurrentWishlist: any
    @wishlist.Getter getWishlistProductPrice: any

    @Prop({
      type: Number,
      required: false,
      default: null,
    })
    readonly index!: number | null

    @Prop({
      required: true,
      type: Object,
    })
    readonly product!: WishlistProduct

    created() {
      this.quantityInOrderUnit = this.product.measurementUnits?.quantityMin ?? 1
    }

    mounted() {
      this.currentValue = this.localNumberOfProducts
    }

    get wishlist(): MappedWishlist {
      return this.getCurrentWishlist
    }

    get prices(): WishlistProductPricesDto | null {
      return this.product.prices ?? null
    }

    get productPrices(): CartProductPrice | null {
      return this.getWishlistProductPrice(this.prices, this.isGrossSelected)
    }

    get hasXXLLabel(): boolean {
      return this.product.labels && this.product.labels.includes('XXL')
    }

    get canonicalCategoryName(): string | null {
      const category = this.getCategory(this.product.canonicalCategory) ?? null
      return category ? category.name : null
    }

    get warehouseStatusClass(): Array<string> {
      return [this.centralQuantityExists ? 'icon-geolocalize' : 'icon-main-warehouse']
    }

    get centralQuantityExists(): boolean {
      if (this.centralQuantity === null) {
        return false
      }
      return !isUndefined(this.centralQuantity) ? this.centralQuantity >= 0 : false
    }

    get centralQuantity() {
      return this.product.parentWarehouseQuantity
    }

    get orderUnitDescription() {
      return this.product.measurementUnits.orderUnitDescription
    }

    get selectedQuantity() {
      return this.product.warehouseQuantity
    }

    get stockAvailable(): boolean {
      return this.product?.availability
    }

    get stockVisibilityModeHidden(): boolean {
      return this.wishlist.stockVisibilityMode === StockVisibilityMode.HIDDEN
    }

    get stockVisibilityModeLabel(): string {
      return this.stockAvailable
        ? (this.$t('stock_visibility_mode.available') as string)
        : (this.$t('stock_visibility_mode.unavailable') as string)
    }

    get localNumberOfProducts(): number {
      return this.product.quantity
    }

    get isTileCalculatorEnabled(): boolean {
      return (
        !!this.product.measurementUnits?.contentUnitDescription &&
        !!this.product.measurementUnits?.packingQuantity &&
        this.product.labels.includes('tile_calculator')
      )
    }

    get currentPrice(): number | undefined {
      return (
        this.productPrices?.price || this.productPrices?.catalogPrice || this.productPrices?.unit
      )
    }

    get unitPrice(): string | undefined {
      if (!this.productPrices) {
        return undefined
      }
      return (
        converters.priceFormatter(this.productPrices.price, this.getCurrency) ||
        converters.priceFormatter(this.productPrices.catalogPrice, this.getCurrency) ||
        converters.priceFormatter(this.productPrices.unit, this.getCurrency)
      )
    }

    get basePrice() {
      if (!this.productPrices) {
        return undefined
      }
      return converters.priceFormatter(this.productPrices.catalogPrice, this.getCurrency)
    }

    get productDiscount(): string | null {
      const discount = this.productPrices && this.productPrices.discount
      return discount ? `${discount} %` : null
    }

    get contentPrice(): string | null {
      if (typeof this.currentPrice === 'undefined') {
        return null
      }
      return (
        converters.priceFormatter(
          parseFloat(
            converters.toPackagingQuantityPrice(
              this.currentPrice,
              this.product.measurementUnits.packingQuantity,
            ),
          ),
          this.getCurrency,
        ) || null
      )
    }

    get url() {
      return this.product.url.trim() !== ''
        ? this.product.url
        : this.$routes.getProductUrl(this.product)
    }

    onOrderQuantityChanged(value: number) {
      this.quantityInOrderUnit = value
      this.changeValue(value)
    }

    changeValue(event: number) {
      const positiveNumber = Math.abs(event)
      this.currentValue = positiveNumber
      this.buttonLoading = true
      setTimeout(() => {
        this.$emit('amount-change', { amount: positiveNumber })
        this.buttonLoading = false
      }, this.debounceValue)
    }

    addToCart() {
      this.buttonLoading = this.$wait.is('creating-checkout-for-cart')
      this.$emit('add-to-cart', { amount: this.currentValue })
    }

    remove() {
      this.$emit('remove')
      this.qtyError = false
    }

    isQtyError(e: boolean) {
      this.qtyError = e
    }

    onContentQuantityChanged(e: any) {
      if (this.product.measurementUnits?.packingQuantity) {
        const value = Math.ceil(e / this.product.measurementUnits?.packingQuantity)
        this.changeValue(value)
      }
    }

    getProductWarehouseClass(shipment: CustomProductShipment): string {
      return shipment.contextWarehouseType === 'LOCAL' ? 'icon-geolocalize' : 'icon-main-warehouse'
    }
  }
